class TemplateOptionsCtrl {
  constructor($timeout) {
    'ngInject';
    this.loading = true;
    this.connectionIsValid = undefined;
    this.$timeout = $timeout;
  }

  async $onInit() {

    this.loading = false;
    if (!this.highlightSec) return;

    this.$timeout(_ => {
      const $highlightObj = $(`${this.highlightSec}`);
      if ($highlightObj.hasClass('panel')) $highlightObj.addClass('panel-info');
      else $highlightObj.addClass('alert alert-info');
    }, 500);
  }

  close() {
    this.onCancel();
  }

}

export default {
  bindings: {
    template: "=",
    referenceId: "=?",
    ignoreLeaveConfirm: "=?",
    highlightSec: "=?",
    onCancel: "&"
  },
  templateUrl: "form-builder/template-options/template-options.component.html",
  controller: TemplateOptionsCtrl
};
